import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";

const UpdateTestCostModal = ({ isOpen, onRequestClose, testId }) => {
  const navigate = useNavigate();
  const [cost, setCost] = useState("");
  const [loading, setLoading] = useState(false);
  const [existingCost, setExistingCost] = useState(null);

  useEffect(() => {
    if (testId && isOpen) {
      fetchExistingCost();
    }
  }, [testId, isOpen]);

  const fetchExistingCost = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const response = await axios.get(`/api/labTestCost/getUpdatedCost/testId=${testId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExistingCost(response.data);
      setCost(response.data?.cost || "");
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch test cost.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!cost || parseFloat(cost) <= 0) {
      toast.error("Please enter a valid cost.");
      return;
    }

    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    try {
      const requestBody = {
        testId: testId,
        cost: parseFloat(cost)
      };

      await axios.post(`/api/labTestCost/create`, requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      toast.success("Test cost updated successfully");
      onRequestClose();
      setCost("");
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleCostChange = (e) => {
    const { value } = e.target;
    setCost(value);
  };

  const handleClose = () => {
    setCost("");
    setExistingCost(null);
    onRequestClose();
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Test Cost</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-12 mx-xl-auto">
          <div className="card card-raised mb-3">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                {existingCost && (
                  <div className="mb-3">
                    <p className="text-muted">
                      Current Cost: <strong>₹{existingCost.cost}</strong>
                    </p>
                  </div>
                )}

                <div className="row">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="cost">
                      New Cost <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="form-control"
                      id="cost"
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="Enter new cost"
                      value={cost}
                      onChange={handleCostChange}
                      required
                    />
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <Button 
                    type="submit" 
                    variant="primary"
                    disabled={loading}
                  >
                    Update Cost
                  </Button>
                  <Button 
                    variant="secondary" 
                    onClick={handleClose}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UpdateTestCostModal;